import React from 'react';
import { Dropdown, IconButton, SelectList } from '@x5-react-uikit/core';
import { sizeTokenValues } from '@x5-react-uikit/tokens';

const DROPDOWN_ITEMS = [
  {
    disabled: true,
    name: 'Коммерческая поддержка:',
    value: 'Коммерческая поддержка:',
  },
  {
    name: 'support.audience@x5.ru',
    value: 'mailto:support.audience@x5.ru',
  },
  {
    disabled: true,
    name: 'Техническая поддержка:',
    value: 'Техническая поддержка:',
  },
  {
    name: 'tech_support.audience@x5.ru',
    value: 'mailto:tech_support.audience@x5.ru ',
  },
];

const Support = () => {
  const handleDropdownClick = (event, value) => {
    window.location.replace(value as string);
  };

  return (
    <Dropdown
      action={
        <IconButton size={sizeTokenValues.small} variant="text" icon="Help" />
      }
      placement="bottom-start"
    >
      <SelectList
        items={DROPDOWN_ITEMS}
        onChange={handleDropdownClick}
        selected={[]}
      />
    </Dropdown>
  );
};

export default Support;
